import React from "react";

import { useGetRecentData } from "api/api-hooks/datasets-hooks";
import { MdmDeviceDto, useGetAllDevicesByProjectQuery } from "gql/generated/types";
import { sample } from "lodash-es";
import { Tag } from "primereact/tag";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";
import { STATUS_UPDATE_TIME } from "../utils/const";

const Devices = () => {
  const { projectId } = useParams();
  const { data, loading } = useGetAllDevicesByProjectQuery({
    variables: { id: projectId! },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const edit = (rowData: MdmDeviceDto) => (
    <Link to={`${rowData.id}`} title="Device Info">
      <i className="pi pi-external-link" />
    </Link>
  );

  const handleStatus = (rowData: MdmDeviceDto) => <Status device={rowData} />

  const columns: TableColumn<MdmDeviceDto>[] = [
    { field: "identifier", header: "Identifier", sortable: true, filter: true },
    {
      field: "objectRelation.mdmObject.title",
      header: "Object Code",
      sortable: true,
      filter: true,
    },
    { field: "tags", header: "Tags", body: rowData => rowData.tags?.join(", ") },
    {
      header: "Status",
      body: handleStatus,
      sortable: true,
      sortField: "boundDatasets.all.length",
      hideInFile: true,
    },
    {
      header: "Actions",
      body: edit,
      hideInFile: true,
      style: {
        width: "10%",
      },
    },
  ];
  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmDevicesByProjectId as MdmDeviceDto[] ?? []}
        searchFields={["identifier", "tags"]}
        isLoading={loading}
        tableName="Devices"
        onToolbarBtnClick={() => navigate("new")}
        toolbarBtnLabel="Add Device"
      />
    </div>
  );
};

export default Devices;


const Status: React.FC<{device: MdmDeviceDto}> = ({device}) => {

  const randomDataset = sample(device.boundDatasets?.all);
  if (!randomDataset) return null;
  return <DatasetStatus identifier={randomDataset.identifier!} threshold={device.config?.vitalityThreshold!}/>;
}

const DatasetStatus: React.FC<{identifier: string, threshold?: number}> = ({identifier, threshold = 1}) => {
  const { data, dataUpdatedAt } = useGetRecentData([identifier], {
    count: 1,
    options: { refetchInterval: STATUS_UPDATE_TIME },
  });

  if (!data) return null;
  
  const vitality = dataUpdatedAt - new Date(data[0].data[0]?.key).getTime()
  
  if (vitality && vitality > threshold * 1000) {
    return <Tag value="Offline" severity="danger" />;
  }
  if (vitality && vitality > 0) {
    return <Tag value="Online" severity="success" />;
  }
  return <Tag value="No Data" severity="danger" />;
}